import type { Locale } from "@/lib/i18n";
import { pl, type WLatestRealizationsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wLatestRealizationsTranslations: Record<Locale, WLatestRealizationsTranslations> = {
  pl,
  en,
  de,
};

export type { WLatestRealizationsTranslations };
